module.exports = __webpack_public_path__ + "static/img/JEBIN.019ee2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/JEBIN.png
// module id = DlgU
// module chunks = 1